import React, {useState} from 'react';
import Customer from '../../../types/Customer';
import AdminRadiobox from '../../admin-radiobox';
import Button from '../../button';
import {getAttributeValue} from "../../../lib/attribute";
import useUpdateCustomerState from "../../../hooks/use-update-customer-state";

interface Props {
  customer: Customer;
}

const AdminUserIsTinValidatedForm: React.FC<Props> = ({ customer }) => {
  const [isTinValidated, setIsTinValidated] = useState(
    getAttributeValue(customer.attributes, 'isTinValidated')
  );

  const [message, setMessage] = useState('');
  const updateIsTinValidatedState = useUpdateCustomerState(() => {
    setMessage('Successfully updated is Taxpayer Identification(TIN) details.');
  });

  const onClick = () => {
    setMessage('');

    updateIsTinValidatedState(
      process.env.SITE as string,
      customer.id,
      'isTinValidated',
      isTinValidated === "true"
    );
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>Is Taxpayer Identification (TIN) validated?</h2>
      <div className="is-tin-validated">
        {[
          {
            id: 'true',
            label: 'Yes',
          },
          {
            id: 'false',
            label: 'No',
          },
          // @ts-ignore
        ].map((s) => (
          <AdminRadiobox
            key={s.id}
            name="status"
            id={s.id}
            label={s.label}
            checked={s.id.toLowerCase() === isTinValidated.toLowerCase()}
            onChange={() => setIsTinValidated(s.id)}
          />
        ))}
      </div>
      <Button text="Save" onClick={onClick}/>
      {message && <p style={{ marginTop: "14px" }}>{message}</p>}
      {/* language=CSS */}
      <style jsx>{`
        .is-tin-validated {
          display: flex;
          flex-wrap: wrap;
        }

        .is-tin-validated > :global(.radiobox-group) {
          flex-grow: 0;
          width: 33%;
          margin-bottom: 1rem;
        }
      `}</style>
    </form>
  );
};

export default AdminUserIsTinValidatedForm;
